var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('uvInput',{attrs:{"value":_vm.value,"type":_vm.type,"fixed":_vm.fixed,"disabled":_vm.disabled,"disabledColor":_vm.disabledColor,"clearable":_vm.clearable,"password":_vm.password,"maxlength":_vm.maxlength,"placeholder":_vm.placeholder,"placeholderClass":_vm.placeholderClass,"placeholderStyle":_vm.placeholderStyle,"showWordLimit":_vm.showWordLimit,"confirmType":_vm.confirmType,"confirmHold":_vm.confirmHold,"holdKeyboard":_vm.holdKeyboard,"focus":_vm.focus,"autoBlur":_vm.autoBlur,"disableDefaultPadding":_vm.disableDefaultPadding,"cursor":_vm.cursor,"cursorSpacing":_vm.cursorSpacing,"selectionStart":_vm.selectionStart,"selectionEnd":_vm.selectionEnd,"adjustPosition":_vm.adjustPosition,"inputAlign":_vm.inputAlign,"fontSize":_vm.fontSize,"color":_vm.color,"prefixIcon":_vm.prefixIcon,"suffixIcon":_vm.suffixIcon,"suffixIconStyle":_vm.suffixIconStyle,"prefixIconStyle":_vm.prefixIconStyle,"border":_vm.border,"readonly":_vm.readonly,"shape":_vm.shape,"customStyle":_vm.customStyle,"formatter":_vm.formatter},on:{"focus":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.$emit('focus')
},"blur":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(function (e) { return _vm.$emit('blur', e); }).apply(void 0, arguments)
},"keyboardheightchange":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.$emit('keyboardheightchange')
},"change":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(function (e) { return _vm.$emit('change', e); }).apply(void 0, arguments)
},"input":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(function (e) { return _vm.$emit('input', e); }).apply(void 0, arguments)
},"confirm":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(function (e) { return _vm.$emit('confirm', e); }).apply(void 0, arguments)
},"clear":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.$emit('clear')
},"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.$emit('click')
}}},[_vm._t("prefix",null,{"slot":"prefix"}),_vm._t("suffix",null,{"slot":"suffix"})],2)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }